import { createApiSlice } from "@common";
import { MY_INFO_ADDRESS_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeAddressType",
    method: "post",
    url: MY_INFO_ADDRESS_CONFIG,
    stateKey: "message",
  },

  {
    name: "getEmployeeAddressType",
    method: "get",
    url: MY_INFO_ADDRESS_CONFIG,
    stateKey: "data",
  },

  {
    name: "updateEmployeeAddressType",
    method: "put",
    url: MY_INFO_ADDRESS_CONFIG,
    stateKey: "message",
  },

  {
    name: "deleteEmployeeAddressType",
    method: "delete",
    url: MY_INFO_ADDRESS_CONFIG,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("engagementLevel", apiConfig, customReducers);
const engagementLevelSlice = slice;

export default engagementLevelSlice.reducer;

export const {
  addEmployeeAddressType,
  getEmployeeAddressType,
  updateEmployeeAddressType,
  deleteEmployeeAddressType,
} = thunks;

export const { rowSelect } = actions;
